$(document).on("turbolinks:load", function () {

  $(function () {
    var fixHelperSize = function (e, ui) {
      ui.children().each(function () {
        $(this).width($(this).width());
      });
      return ui;
    };

    var order;
    if ($(".sortable-photos").length) {
      $(".sortable-photos").sortable({
        placeholder: 'sortable-photos-placeholder',
        helper: fixHelperSize,
        axis: 'y',
        handle: '.sort-handler',
        update: function (event, ui) {
          var order;
          order = $(this).sortable('toArray', {
            attribute: 'data-order'
          });
          return $.ajax({
            url: $(this).data('url'),
            type: 'PUT',
            data: {
              order: order
            }
          });
        }
      })
    }
    // $(".sortable-photos").disableSelection();
  });

});
